import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Order } from '../order';

@Component({
    selector: 'pdf-dialog',
    templateUrl: 'pdf.component.html',
  })
  export class PdfDialog {

    pdf;
    constructor(
        public dialogRef: MatDialogRef<PdfDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
            this.pdf = this.data;

        }

  }